module.exports = __webpack_public_path__ + "static/img/service_introduce_VN01_zh_h5.735efff.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/service/service_introduce_VN01_zh_h5.png
// module id = QRNF
// module chunks = 34